var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panel',{staticClass:"mt-3"},[_c('v-expansion-panel-header',[_vm._t("title")],2),_c('v-expansion-panel-content',{staticClass:"signLine-content"},[_vm._t("component")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }